<template>
    <router-view></router-view>
</template>

<script>

export default {
    computed: {
    },
    methods: {
        getDesignId() {
            return this.$route.params.designId || this.$route.params.id;
        },
    },
    mounted() {
        let designId = this.getDesignId();

    	this.$store.dispatch('submittalStandards/load');
        this.$store.dispatch('submittalStandards/setIdFromRecord', designId)
            .then(() => {
                return this.$store.dispatch('submittalPipes/retrievePipes');
            })
            .then(() => {
                this.$store.dispatch('submittalSystem/calculateWeights');
            });
    },
};
</script>